<template>
  <DefaultLayout class="!bg-slate-50">
    <v-row class="mx-5 mt-2 font-inter">
      <v-col cols="12">
        <div class="flex justify-start items-center gap-1">
          <h5
            class="text-xs text-red-600 cursor-pointer"
            @click="$router.push('/')"
          >
            Home
          </h5>
          <i class="mdi mdi-chevron-right text-xl"></i>
          <span class="text-xs text-black">Pengaturan</span>
        </div>
        <h2 class="font-bold text-2xl text-[#232323] font-inter">Pengaturan</h2>
      </v-col>
      <v-col cols="12" class="bg-white shadow-md p-3 rounded-md mb-10">
        <div class="flex justify-end">
          <v-btn
            class="capitalize text-xs min-w-40 w-40 bg-gray-800"
            @click="isEdit = true"
            v-if="!isEdit"
          >
            <span class="text-white text-sm">Edit</span>
            <template v-slot:prepend>
              <img
                src="../../assets/icon/edit.png"
                alt="icon"
                class="w-5 h-auto"
                loading="lazy"
              />
            </template>
          </v-btn>
          <div class="flex gap-3" v-else>
            <v-btn
              class="min-w-40 w-40 border-gray-500 bg-white"
              variant="outlined"
              @click="cancelEdit"
            >
              <span class="capitalize text-gray-600 text-sm">Batal</span>
            </v-btn>
            <v-btn
              variant="text"
              class="min-w-40 w-40 bg-red-600"
              id="btn-submit"
              @click="submitData"
            >
              <span class="capitalize text-white text-sm font-medium">
                Submit
              </span>
              <img
                src="../../assets/icon/send.png"
                alt="Submit Icon"
                class="ml-2 h-4 w-auto"
              />
            </v-btn>
          </div>
        </div>

        <hr class="my-3 border-t-2 border-dashed border-gray-500" />

        <v-form ref="formData">
          <div class="grid grid-cols-3 gap-3">
            <div>
              <label for="" class="text-[10px]">Formula</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                V<span class="text-xs">{{ data.formula_version }}</span>
              </h3>
              <v-autocomplete
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                :items="[
                  { value: 1, title: 'V1' },
                  { value: 2, title: 'V2' },
                ]"
                :rules="formValidasi.formula_version"
                v-model="data.formula_version"
              ></v-autocomplete>
            </div>
            <div v-if="data.formula_version === 1">
              <label for="" class="text-[10px]">
                Faktor Emisi V<span class="text-[8px]">1</span>
              </label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.electrical_emission_factor }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.electrical_emission_factor"
                @input="handleInput($event, 'electrical_emission_factor')"
                :rules="formValidasi.electrical_emission_factor"
              ></v-text-field>
            </div>
            <div v-if="data.formula_version === 2">
              <label for="" class="text-[10px]">
                Faktor Emisi V<span class="text-[8px]">2</span>
              </label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.factor_emission }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.factor_emission"
                @input="handleInput($event, 'factor_emission')"
                :rules="formValidasi.factor_emission"
              ></v-text-field>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-3" v-if="data.formula_version === 2">
            <div>
              <label for="" class="text-[10px]"> Faktor Konversi</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.factor_conversion }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.factor_conversion"
                @input="handleInput($event, 'factor_conversion')"
                :rules="formValidasi.factor_conversion"
              ></v-text-field>
            </div>
            <div>
              <label for="" class="text-[10px]">Konversi Metana</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.conversion_methane }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.conversion_methane"
                @input="handleInput($event, 'conversion_methane')"
                :rules="formValidasi.conversion_methane"
              ></v-text-field>
            </div>
            <div>
              <label for="" class="text-[10px]">Konversi CO2</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.conversion_co2 }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.conversion_co2"
                @input="handleInput($event, 'conversion_co2')"
                :rules="formValidasi.conversion_co2"
              ></v-text-field>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-3" v-if="data.formula_version === 2">
            <div>
              <label for="" class="text-[10px]"> Faktor Emisi EBT</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.factor_emission_ebt }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.factor_emission_ebt"
                @input="handleInput($event, 'factor_emission_ebt')"
                :rules="formValidasi.factor_emission_ebt"
              ></v-text-field>
            </div>
            <div>
              <label for="" class="text-[10px]"> Faktor Emisi Non EBT</label>
              <h3 class="text-base -mt-1 font-semibold" v-if="!isEdit">
                <span class="text-xs">
                  {{ data.factor_emission_non_ebt }}
                </span>
              </h3>
              <v-text-field
                v-else
                variant="outlined"
                density="compact"
                color="#475569"
                hide-details="auto"
                v-model="data.factor_emission_non_ebt"
                @input="handleInput($event, 'factor_emission_non_ebt')"
                :rules="formValidasi.factor_emission_non_ebt"
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<script>
import util from "@/assets/js/util";
import { APP_BACKEND_ESG } from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import axios from "axios";
import { formatNumber } from "../esg/core/FormData";
import { FormValidasiDataSetting } from "./core/FormData";

const base_url = APP_BACKEND_ESG;

export default {
  name: "SettingPage",
  components: { DefaultLayout },
  data() {
    return {
      id: null,
      data: {
        formula_version: null,
        electrical_emission_factor: null,
        factor_emission_ebt: null,
        factor_emission_non_ebt: null,
        factor_emission: null,
        factor_conversion: null,
        conversion_methane: null,
        conversion_co2: null,
      },
      formValidasi: FormValidasiDataSetting,
      isEdit: false,
    };
  },
  mounted() {
    this.getSetting();
  },
  methods: {
    async getSetting() {
      try {
        const response = await axios.get(`${base_url}/sys-setting`);

        this.id = response.data.data.id;

        this.data.formula_version = response.data.data.formula_version;
        this.data.electrical_emission_factor =
          response.data.data.electrical_emission_factor;
        this.data.factor_emission = response.data.data.factor_emission;
        this.data.factor_conversion = response.data.data.factor_conversion;
        this.data.conversion_methane = response.data.data.conversion_methane;
        this.data.conversion_co2 = response.data.data.conversion_co2;
        this.data.factor_emission_ebt = response.data.data.factor_emission_ebt;
        this.data.factor_emission_non_ebt =
          response.data.data.factor_emission_non_ebt;
      } catch (err) {
        util.showError(err);
      }
    },
    cancelEdit() {
      this.isEdit = false;
      this.getSetting();
    },
    async submitData() {
      try {
        const validate = await this.$refs.formData.validate();

        if (validate.valid) {
          this.isEdit = false;
          const response = await axios.put(
            `${base_url}/sys-setting/${this.id}`,
            this.data
          );
          util.showInfo(response.data.message);
          this.getSetting();
        }
      } catch (err) {
        util.showError(err);
      }
    },
    handleInput(event, column) {
      let textField = event.target;
      if (!textField) return;

      let cursorPosition = textField.selectionStart;
      let formattedValue = formatNumber(textField.value);

      let lengthDiff = formattedValue.length - textField.value.length;
      let newCursorPosition = cursorPosition + lengthDiff;

      this.data[column] = formattedValue;

      this.$nextTick(() => {
        textField.setSelectionRange(newCursorPosition, newCursorPosition);
      });
    },
  },
};
</script>
